import React, { useState, useEffect } from "react";
import axios from "axios";
import Heros from "../components/Heros";
import AboutImg from "../assets/PCTC.jpg";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const PCTC2 = () => {
  // State for schedules and loading
  const [schedules, setSchedules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch schedules data from API
  useEffect(() => {
    const fetchSchedules = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        // Fetch schedules from API
        const response = await axios.get('https://site2.akms.org.in/api/pctc2');
        setSchedules(response.data);
      } catch (error) {
        console.error('Error fetching schedules:', error);
        setError('Failed to load schedules. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchedules();
  }, []);

  // Parse ports and dates into arrays
  const parseCommaList = (commaList) => {
    if (!commaList) return [];
    return commaList.split(',').map(item => item.trim());
  };

  return (
    <>
      <Navbar
        Home="Home"
        About="Fleet List"
        Contact="Enquiry"
        Fleet="Break Bulk"
        PCTC="PCTC"
        More="Schedule"
        IntraAsia="Intra-Asia"
        Bay_Bengal="Bay of Bengal"
        Login="Login"
        PCTC2="PCTC"
      />

      <Heros
        cName="hero-mid"
        heroImg={AboutImg}
        url="/"
      />

      <div style={styles.pageContainer}>
        <div style={styles.titleContainer}>
          <h1 style={styles.pageTitle}>Sailing Schedule</h1>
        </div>

        {isLoading ? (
          <div style={styles.loadingMessage}>Loading schedules...</div>
        ) : error ? (
          <div style={styles.errorMessage}>{error}</div>
        ) : schedules.length === 0 ? (
          <div style={styles.noDataMessage}>No schedules available at this time.</div>
        ) : (
          <div style={styles.tableWrapper}>
            {schedules.map((schedule, index) => {
              const ports = parseCommaList(schedule.calling_ports);
              const dates = parseCommaList(schedule.etd_dates);
              
              return (
                <div key={schedule.id || index} style={styles.scheduleContainer}>
                  <div style={styles.headerRow}>
                    <div style={styles.vesselNameCell} title={`Vessel: ${schedule.vessel_name}${schedule.lolo ? " (LOLO)" : " (RORO)"}`}>
                      {schedule.vessel_name} {schedule.lolo ? "(LOLO)" : "(RORO)"}
                    </div>
                    <div style={styles.voyageCell}>
                      <div>Voyage</div>
                      <div title={`Voyage: ${schedule.voyage}`}>{schedule.voyage}</div>
                    </div>
                    <div style={styles.capacityCell}>
                      <div>LIFTING CAPACITY</div>
                      <div title={`Lifting Capacity: ${schedule.lifting_capacity}`}>{schedule.lifting_capacity}</div>
                    </div>
                  </div>
                  
                  <div style={styles.tableScrollContainer}>
                    <table style={styles.dataTable}>
                      <tbody>
                        <tr>
                          <td style={styles.labelCell} title="Calling Ports">Calling ports</td>
                          {ports.map((port, i) => (
                            <td 
                              key={`port-${i}`} 
                              style={styles.dataCell} 
                              title={`Vessel: ${schedule.vessel_name} | Port: ${port} | Date: ${dates[i] || 'N/A'}`}
                            >
                              {port}
                            </td>
                          ))}
                        </tr>
                        <tr>
                          <td style={styles.labelCell} title="Estimated Date">Est. date</td>
                          {dates.map((date, i) => (
                            <td 
                              key={`date-${i}`} 
                              style={styles.dataCell} 
                              title={`Vessel: ${schedule.vessel_name} | Port: ${ports[i] || 'N/A'} | Date: ${date}`}
                            >
                              {date}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  {/* Display any additional fields if they exist */}
                  {Object.keys(schedule).map(key => {
                    // Skip standard fields and internal fields that start with underscore or id fields
                    if (['id', 'vessel_name', 'voyage', 'calling_ports', 'etd_dates', 'lifting_capacity', 'lolo', 'created_at', 'updated_at'].includes(key) || 
                        key.startsWith('_') || 
                        key === 'id') {
                      return null;
                    }
                    
                    const fieldLabel = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                    
                    return (
                      <div key={key} style={styles.additionalField}>
                        <div style={styles.fieldLabel} title={fieldLabel}>
                          {fieldLabel}
                        </div>
                        <div 
                          style={styles.fieldValue} 
                          title={`Vessel: ${schedule.vessel_name} | ${fieldLabel}: ${schedule[key]}`}
                        >
                          {schedule[key]}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

// Inline styles object
const styles = {
  pageContainer: {
    width: "100%",
    backgroundColor: "white",
    padding: "0 0 40px 0",
  },
  titleContainer: {
    width: "100%",
    textAlign: "center",
    padding: "20px 0",
  },
  pageTitle: {
    color: "#fff",
    fontSize: "28px",
    fontWeight: "500",
    margin: 0,
  },
  tableWrapper: {
    width: "95%",
    maxWidth: "1400px",
    margin: "0 auto",
    backgroundColor: "white",
    borderRadius: "4px",
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  scheduleContainer: {
    marginBottom: "1px",
    borderBottom: "1px solid #e0e0e0",
  },
  headerRow: {
    display: "flex",
    backgroundColor: "#36304a",
    color: "white",
    fontWeight: "bold",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  vesselNameCell: {
    width: "200px",
    padding: "10px 15px",
    textTransform: "uppercase",
    borderRight: "1px solid #4a4663",
    display: "flex",
    alignItems: "center",
    position: "relative",
    cursor: "default",
  },
  voyageCell: {
    width: "100px",
    padding: "5px 10px",
    textAlign: "center",
    borderRight: "1px solid #4a4663",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
    cursor: "default",
  },
  capacityCell: {
    flex: "1",
    padding: "5px 10px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
    cursor: "default",
  },
  tableScrollContainer: {
    overflowX: "auto",
    width: "100%",
    position: "relative",
    scrollbarWidth: "thin",
    scrollbarColor: "#90A4AE #CFD8DC",
  },
  dataTable: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "100%", // Ensures table is at least as wide as container
  },
  labelCell: {
    width: "120px",
    padding: "10px 15px",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #dee2e6",
    borderBottom: "1px solid #dee2e6",
    textAlign: "left",
    verticalAlign: "middle",
    position: "sticky",
    left: 0,
    zIndex: 5,
    cursor: "default",
  },
  dataCell: {
    padding: "10px 15px",
    textAlign: "center",
    borderRight: "1px solid #dee2e6",
    borderBottom: "1px solid #dee2e6",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    position: "relative",
    cursor: "default",
    minWidth: "120px", // Ensure cells have minimum width
  },
  additionalField: {
    display: "flex",
    borderTop: "1px solid #dee2e6",
  },
  fieldLabel: {
    width: "120px",
    padding: "10px 15px",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #dee2e6",
    fontWeight: "bold",
    position: "sticky",
    left: 0,
    zIndex: 5,
    cursor: "default",
  },
  fieldValue: {
    flex: 1,
    padding: "10px 15px",
    position: "relative",
    cursor: "default",
    overflowX: "auto",
  },
  loadingMessage: {
    textAlign: "center",
    padding: "30px",
    fontSize: "16px",
    color: "#fff",
  },
  errorMessage: {
    textAlign: "center",
    padding: "30px",
    color: "#ff6b6b",
    fontSize: "16px",
  },
  noDataMessage: {
    textAlign: "center",
    padding: "30px",
    color: "#aaa",
    fontSize: "16px",
  },
};

export default PCTC2;